import { Tooltip } from "@smartrent/ui";

import { ExclamationCircle } from "@smartrent/icons";

import Helpers from "@/lib/helpers";

interface HoverTextProps {
  hoverElement?: any;
  tooltipDirection?: "top" | "right" | "left" | "bottom";
  tooltipText: string;
  width?: number;
  color?: string;
}

export default function HoverText({
  hoverElement,
  tooltipText,
  color,
}: HoverTextProps) {
  const id = `tooltip-${Math.floor(Math.random() * 1000) + 1}`;
  // rudimentary randomizer to get different id's if there are multiple
  // tooltips on a page for screen readers

  return (
    <Tooltip title={tooltipText} name={id}>
      <span aria-describedby={id}>
        {hoverElement ? (
          hoverElement
        ) : (
          <ExclamationCircle size={16} color={color || Helpers.colors.green} />
        )}
      </span>
    </Tooltip>
  );
}
